module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-indicator"
  }, [_vm._t("header", [_c('h6', [_vm._v("Statystyki")])]), _vm._v(" "), _c('div', {
    staticClass: "indicator-text"
  }, [_c('div', {
    staticClass: "circle-icon"
  }, [_c('i', {
    class: _vm.icon
  })]), _vm._v(" "), _c('div', {
    staticClass: "stats-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.stats))]), _vm._v(" " + _vm._s(_vm.unit) + "\n    ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d82dade","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/statsIndicator.vue
// module id = 389
// module chunks = 0